import { jsx } from 'react/jsx-runtime';

const Pill = ({ variant = 'success', children }) => {
    const base = 'w-full rounded-radius-200 px-space-400 py-space-200';
    const zones = {
        primary: 'bg-(--button-bg-primary-color) text-(--button-text-primary-color) border-(--button-border-primary-color)',
        error: 'bg-(--color-error-700) text-(--color-neutral-0) border-(--color-error-700)',
        warning: 'bg-(--color-warning-400) text-(--color-neutral-900) border-(--color-warning-700)',
        success: 'bg-(--color-success-600) text-(--color-neutral-0) border-(--color-success-600)',
        successLight: 'bg-(--color-success-100) text-(--color-success-600) border-(--color-success-600)',
        neutral: 'bg-(--color-neutral-200) text-(--color-neutral-800) border-(--color-neutral-200)',
    };
    return jsx("div", { className: `${base} pill ${zones[variant]}`, children: children });
};

export { Pill };
